const ZERO_EPSILON = 0.005;

/**
 * Bakiye kartı için işaretli tutar: 0 → işaretsiz, pozitif → +, negatif → -
 * @param {number} amount
 * @param {(n: number) => string} formatAmount - mutlak veya ham değeri biçimlendirir (₺ dahil)
 */
export function formatSignedBalance(amount, formatAmount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) {
    return formatAmount(0);
  }
  if (Math.abs(n) < ZERO_EPSILON) {
    return formatAmount(0);
  }
  if (n > 0) {
    return `+${formatAmount(n)}`;
  }
  return `-${formatAmount(Math.abs(n))}`;
}
